import { render, staticRenderFns } from "./BookingPriceSummary.vue?vue&type=template&id=0c3e341f&scoped=true&"
import script from "./BookingPriceSummary.vue?vue&type=script&lang=js&"
export * from "./BookingPriceSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingPriceSummary.vue?vue&type=style&index=0&id=0c3e341f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e341f",
  null
  
)

export default component.exports